import React, { useEffect, useRef, useState } from "react";
import Grid from "@material-ui/core/Grid";
import {
  getAutocompleteLabel,
  normalizeAutocompleteValue,
} from "../../../utils/autocomplete";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import "date-fns";
import Button from "@material-ui/core/Button";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import Dialog from "@material-ui/core/Dialog";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import AddressField from "./AddressField";
const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    width: `calc(100% - ${theme.spacing(2)}px)`,
    minWidth: 0,
    "& .MuiAutocomplete-root": { width: "100%" },
    "& .MuiFormControl-root": { width: "100%", minWidth: 0 },
    "& .MuiInputBase-root": { width: "100%" },
  },
  formControl2: {
    margin: theme.spacing(1),
    width: `calc(100% - ${theme.spacing(2)}px)`,
    minWidth: 0,
    "& .MuiAutocomplete-root": { width: "100%" },
    "& .MuiFormControl-root": { width: "100%", minWidth: 0 },
    "& .MuiInputBase-root": { width: "100%" },
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
    flexWrap: "wrap",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
}));

export default function TercerPaciente(props) {
  const classes = useStyles();
  const filter = createFilterOptions();
  const [inputValue, setInputValue] = useState("");
  const geocoderRef = useRef(null);
  const autoSvcRef = useRef(null);
  const [preds, setPreds] = useState([]);
  const [pickerOpen, setPickerOpen] = useState(false);
  const [pendingKeys, setPendingKeys] = useState({
    dirKey: null,
    coordsKey: null,
  });
  useEffect(() => {
    if (window.google?.maps) {
      if (!geocoderRef.current)
        geocoderRef.current = new window.google.maps.Geocoder();
      if (!autoSvcRef.current)
        autoSvcRef.current =
          new window.google.maps.places.AutocompleteService();
    }
  }, []);
  function choosePrediction(pred) {
    setPickerOpen(false);
    setPreds([]);
    const { dirKey, coordsKey } = pendingKeys || {};
    setPendingKeys({ dirKey: null, coordsKey: null });
    if (!pred?.place_id || !dirKey || !coordsKey) return;
    geocodePlaceId(pred.place_id, dirKey, coordsKey);
  }
  function suggestDireccion(dirKey, coordsKey) {
    const raw = (props.values[dirKey] || "").trim();
    if (!raw || raw.length < 8 || !autoSvcRef.current) return;

    autoSvcRef.current.getPlacePredictions(
      {
        input: raw,
        componentRestrictions: { country: ["es", "and"] },
        types: ["geocode"],
      },
      (predictions, status) => {
        const OK = window.google.maps.places.PlacesServiceStatus.OK;
        if (status !== OK || !predictions?.length) {
          // 0 sugerencias → geocode directo del texto y guardar coords
          geocodeAddressWithFallback(raw, dirKey, coordsKey);
          return;
        }

        if (predictions.length === 1) {
          // 1 sugerencia → geocode por placeId y guardar coords
          const p = predictions[0];
          geocodePlaceId(p.place_id, dirKey, coordsKey);
          return;
        }

        // >1 sugerencia → abrir selector (Dialog)
        setPendingKeys({ dirKey, coordsKey });
        setPreds(predictions.slice(0, 7));
        setPickerOpen(true);
      }
    );
  }
  function saveFromResult(r, dirKey, coordsKey) {
    if (!r?.geometry) return;
    const lat = r.geometry.location.lat();
    const lng = r.geometry.location.lng();
    props.handleDataDireccion(dirKey)(
      r.formatted_address || r.description || ""
    );
    props.handleDataCoordenadas(coordsKey)(`${lat},${lng}`);
  }
  function geocodePlaceId(placeId, dirKey, coordsKey) {
    if (!placeId || !geocoderRef.current) return;
    geocoderRef.current.geocode({ placeId }, (results, status) => {
      if (status === "OK" && results?.[0]) {
        saveFromResult(results[0], dirKey, coordsKey);
      } else {
      }
    });
  }
  function geocodeAddressWithFallback(raw, dirKey, coordsKey) {
    if (!geocoderRef.current) return;
    geocoderRef.current.geocode(
      { address: raw, componentRestrictions: { country: ["es", "and"] } },
      (results, st) => {
        if (st === "OK" && results?.[0]) {
          saveFromResult(results[0], dirKey, coordsKey);
        } else {
          geocoderRef.current.geocode(
            { address: raw, componentRestrictions: { country: "ad" } },
            (res2, st2) => {
              if (st2 === "OK" && res2?.[0]) {
                saveFromResult(res2[0], dirKey, coordsKey);
              } else {
              }
            }
          );
        }
      }
    );
  }
  const handleChange = (e) => {
    const value = e.target.value;
    setInputValue(value); // Actualiza el valor del input
    props.handleDataDireccion("direccionTercerPaciente")(value); // Actualiza el estado con el valor del input
  };

  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        Datos del tercer paciente (OPCIONAL)
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <FormControl className={classes.formControl}>
            <Autocomplete
              // value={props.values.puebloPrimerPaciente}
              onChange={(event, newValue) => {
                if (typeof newValue === "string") {
                  props.handlePacientes(newValue);
                } else if (newValue && newValue.inputValue) {
                  // Create a new value from the user input
                  props.handlePacientes(newValue.inputValue);
                } else {
                  props.handlePacientes(newValue);
                }
              }}
              filterOptions={(options, params) => filter(options, params)}
              selectOnFocus
              clearOnBlur
              handleHomeEndKeys
              id="free-solo-with-text-demo"
              options={props.values.pacientes}
              getOptionLabel={(option) => getAutocompleteLabel(option, "nombre")}
              renderOption={(option) => option.etiqueta || option.nombre}
              // style={{ width: 300 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Busca un Paciente"
                  variant="outlined"
                />
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl className={classes.formControl}>
            <Autocomplete
              value={normalizeAutocompleteValue(props.values.puebloTercerPaciente)}
              onChange={(event, newValue) => {
                if (typeof newValue === "string") {
                  props.handlePueblo(newValue);
                } else if (newValue && newValue.inputValue) {
                  // Create a new value from the user input
                  props.handlePueblo(newValue.inputValue);
                } else {
                  props.handlePueblo(newValue);
                }
              }}
              filterOptions={(options, params) => {
                const filtered = filter(options, params);

                // Suggest the creation of a new value
                if (params.inputValue !== "") {
                  filtered.push({
                    inputValue: params.inputValue,
                    title: `Usar: "${params.inputValue}"`,
                  });
                }

                return filtered;
              }}
              selectOnFocus
              clearOnBlur
              handleHomeEndKeys
              id="free-solo-with-text-demo"
              options={props.values.pueblos}
              getOptionLabel={(option) => getAutocompleteLabel(option)}
              renderOption={(option) => option.title}
              // style={{ width: 300 }}
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Escribe un pueblo"
                  variant="outlined"
                />
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl className={classes.formControl}>
            <TextField
              value={props.values.tercerPaciente}
              required
              id="city"
              name="city"
              label="Nombre y apellido"
              fullWidth
              autoComplete="shipping address-level2"
              onChange={props.handleData("tercerPaciente")}
              defaultValue={props.values.tercerPaciente}
              inputProps={{
                maxLength: 40,
              }}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl className={classes.formControl}>
            <AddressField
              label="Dirección Tercer Paciente"
              dirKey="direccionTercerPaciente"
              coordsKey="coordenadasP3"
              value={props.values.direccionTercerPaciente}
              onChange={handleChange}
              suggestDireccion={suggestDireccion}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl className={classes.formControl}>
            <TextField
              value={props.values.telfTercerPaciente}
              required
              id="city"
              name="city"
              label="Teléfono"
              fullWidth
              autoComplete="shipping address-level2"
              onChange={props.handleData("telfTercerPaciente")}
              defaultValue={props.values.telfTercerPaciente}
              inputProps={{
                maxLength: 50,
              }}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl className={classes.formControl}>
            <TextField
              value={props.values.telfTercerPaciente2}
              id="city"
              name="city"
              label="Teléfono alternativo"
              fullWidth
              autoComplete="shipping address-level2"
              onChange={props.handleData("telfTercerPaciente2")}
              defaultValue={props.values.telfTercerPaciente2}
              inputProps={{
                maxLength: 50,
              }}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl className={classes.formControl}>
            <TextField
              value={props.values.NASS3}
              required
              id="city"
              name="city"
              label="NASS-CIP"
              fullWidth
              autoComplete="shipping address-level2"
              onChange={props.handleData("NASS3")}
              defaultValue={props.values.NASS3}
              inputProps={{
                maxLength: 18,
              }}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Dialog
        open={pickerOpen}
        onClose={() => setPickerOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <List>
          {preds.map((p) => (
            <ListItem
              button
              key={p.place_id}
              onClick={() => choosePrediction(p)}
            >
              <ListItemText
                primary={p.structured_formatting?.main_text || p.description}
                secondary={p.structured_formatting?.secondary_text || ""}
              />
            </ListItem>
          ))}
        </List>
      </Dialog>
      <div className={classes.buttons}>
        {props.activeStep !== 0 && (
          <Button onClick={props.prevStep} className={classes.button}>
            Regresar
          </Button>
        )}
        <Button
          variant="contained"
          color="primary"
          onClick={props.nextStep}
          className={classes.button}
        >
          {props.activeStep === 8 && props.activeStep < 9
            ? "Solicitar viaje"
            : "Siguiente"}
        </Button>
      </div>
    </React.Fragment>
  );
}
